import service from "../util/axios"

export const sendCode = (phone) => {
    return service.post('/tool/sendCode', { phone })   
}
export const loginByCaptcha = data => {
    return service.post('/user/account/loginByCaptcha', data)
}
export const register = data => {
    return service.post('/user/account/register', data)
}

export const getUserInfo = () => {
    return service.post('/user/account/userInfo')
}

export const loginOut = () => {
    return service.post('/user/account/loginOut')
}
export const wxPay = (data) => {
    return service.post('/wxPayWebSound/createOrder', data)
}
export const aliPay = (data) =>{
    return service.post('/alipay/soundPay', data)
}
export const loginByPassword = data => {
    return service.post('/user/account/loginByPassword', data)
}


// WEBPACK FOOTER //
// ./src/api/index.js